import * as angular from "angular";

angular
    .module("adminTheme", ["ngMaterial"])
    .config(($mdThemingProvider: any) => {
        const primaryColor = "#00855A"; //Primary colour for this brand
        const darkColor = "#0D1329"; //Dark color used for sidebar navigation
        const lightBackgroundColor = "#FBF9F6"; //Main background color, should be close to grey with a hint of primary color

        $mdThemingProvider.definePalette("main", {
            50: "e0f5ec",
            100: "b3e6d1",
            200: "88f8c5",
            300: "4dc99a",
            400: "26a97c",
            500: "00855a",
            600: "007a52",
            700: "006c47",
            800: "005e3e",
            900: "00452c",
            A100: "88f8c5",
            A200: "6addaa",
            A400: "00855a",
            A700: "005e3e",
            contrastDefaultColor: "light",
            contrastLightColors: [
                "400",
                "500",
                "600",
                "700",
                "800",
                "900",
                "A400",
                "A700",
            ],
        });

        // ------------------------------------------------
        // ------------------------------------------------
        // ------------------------------------------------
        // YOU DO NOT NEED TO EDIT ANYTHING BELOW THIS LINE
        // ------------------------------------------------
        // ------------------------------------------------
        // ------------------------------------------------

        const grey = $mdThemingProvider.extendPalette("grey", {
            50: lightBackgroundColor,
        });

        $mdThemingProvider.definePalette("navbarPalette", {
            50: primaryColor,
            100: primaryColor,
            200: primaryColor,
            300: primaryColor,
            400: primaryColor,
            500: primaryColor,
            600: primaryColor,
            700: primaryColor,
            800: primaryColor,
            900: primaryColor,
            A100: primaryColor,
            A200: primaryColor,
            A400: primaryColor,
            A700: primaryColor,
            contrastDefaultColor: "light",
            contrastDarkColors: [
                "50",
                "100",
                "200",
                "300",
                "A100",
                "A200",
                "A400",
                "A700",
            ],
            contrastLightColors: ["400", "500", "600", "700", "800", "900"],
        });

        $mdThemingProvider.definePalette("darkBrand", {
            50: darkColor,
            100: darkColor,
            200: darkColor,
            300: darkColor,
            400: darkColor,
            500: darkColor,
            600: darkColor,
            700: darkColor,
            800: darkColor,
            900: darkColor,
            A100: darkColor,
            A200: darkColor,
            A400: darkColor,
            A700: darkColor,
            contrastDefaultColor: "light",
        });

        $mdThemingProvider.definePalette("white", {
            50: "#000",
            100: "#000", //tab item non selected colour
            200: "#000", //body background colour
            300: "#000",
            400: "#000", //search box
            500: "#000",
            600: "#000", //select option selected
            700: "#000",
            800: "#000",
            900: "#000",
            A100: "#000",
            A200: "#000", //toolbar background color
            A300: "#000",
            A400: "#000",
            A700: "#000",
            contrastDefaultColor: "dark", // whether, by default, text (contrast)
        });

        $mdThemingProvider
            .theme("darkBackground")
            .primaryPalette("darkBrand")
            .accentPalette("darkBrand")
            .warnPalette("red")
            .backgroundPalette("darkBrand")
            .dark();

        $mdThemingProvider.definePalette("brandGrey", grey);

        $mdThemingProvider
            .theme("navbar")
            .primaryPalette("navbarPalette")
            .accentPalette("navbarPalette")
            .warnPalette("red")
            .backgroundPalette("brandGrey");

        $mdThemingProvider
            .theme("default")
            .primaryPalette("main")
            .accentPalette("white")
            .warnPalette("red")
            .backgroundPalette("brandGrey");
    });
